<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<div class="col-md-12 form-group-inline" v-bind:class="{ 'is-invalid': errors.has('Tanggal Pengangkutan')}">
						<label class="col-form-label col-md-3">Tanggal Pengangkutan</label>
						<div class="col-md-3">
							<input type="hidden" v-model="models.TglAngkut" v-validate="'required'" data-vv-name="Tanggal Pengangkutan"/>
							<date-picker input-class="form-control" 
								v-model="models.TglAngkut" 
								:editable="false" 
								:clearable="false" 
								format="YYYY-MM-DD" 
								:disabled-date="disabledDate"
								valueType="format"></date-picker>
							<div v-if="errors.has('Tanggal Pengangkutan')">
								<p class="text-danger mb-0">{{ errors.first('Tanggal Pengangkutan') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Dari Lokasi Penyimpanan (Skala Kota)</label>
						<div class="col-md-9">
							<div class="col-sm-12 no-padding">
								<label class="radio-inline no-padding">
									<input type="radio" v-model="models.Skala" value="kecamatan" @click="models.JenisFasilitas = '6'">
									<span>Kecamatan</span>
								</label>
								<label class="radio-inline">
									<input type="radio" v-model="models.Skala" value="kota" @click="models.JenisFasilitas = '5'">
									<span>Kota</span>
								</label>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Kota</label>
						<div class="col-md-9">
							<select v-model="models.KotaId" :disabled="config.disabled.kota" v-validate="'required'" @change="getDistrictByCity(true)" data-vv-name="Kota"
								class="form-control">
								<option value="">Pilih Kota</option>
								<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
									{{v.namaKota}}
								</option>
							</select>
							<div v-if="errors.has('Kota')">
								<p class="text-danger mb-0">{{ errors.first('Kota') }}</p>
							</div>
						</div>
					</div>

					<div v-if="models.Skala == 'kecamatan'" class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Kecamatan</label>
						<div class="col-md-9">
							<select v-model="models.KecamatanId" :disabled="config.disabled.kecamatan" v-validate="'required'" @change="getFasilitasB3()" data-vv-name="Kecamatan"
								class="form-control">
								<option value="">Pilih Kecamatan</option>
								<option v-for="(v,i) in masters.districts" :value="v.id" :key="i">
									{{v.namaKecamatan}}
								</option>
							</select>
							<div v-if="errors.has('Kecamatan')">
								<p class="text-danger mb-0">{{ errors.first('Kecamatan') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Jenis Fasilitas</label>
						<div class="col-md-9">
							{{ models.JenisFasilitas == '6' ? 'FPSSB3 Kecamatan' : 'FPSSB3 Kota' }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Fasilitas B3</label>
						<div class="col-md-9">
							<select v-model="models.FasilitasB3Id" @change="getFasilitasB3Row" v-validate="'required'" data-vv-name="Fasilitas B3"
								class="form-control">
								<option value="">Pilih Fasilitas B3</option>
								<option v-for="(v,i) in masters.fasilitasB3" :value="v.id" :key="i">
									{{v.namaFasilitas}}
								</option>
							</select>
							<div v-if="errors.has('Fasilitas B3')">
								<p class="text-danger mb-0">{{ errors.first('Fasilitas B3') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Alamat Fasilitas B3</label>
						<div class="col-md-9">
							{{ models.FasilitasB3Alamat || "-" }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Unit (Suku Dinas)</label>
						<div class="col-md-9">
							<select v-model="models.SudinId" v-validate="'required'" @change="getPihak3(true)" data-vv-name="Sudin"
								class="form-control">
								<option value="">Pilih Sudin</option>
								<option v-for="(v,i) in masters.sudin" :value="v.id" :key="i">
									{{v.namaSudin}}
								</option>
							</select>
							<div v-if="errors.has('Sudin')">
								<p class="text-danger mb-0">{{ errors.first('Sudin') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Pihak Tiga</label>
						<div class="col-md-9">
							<select v-model="models.Pihak3Id" @change="getPihak3Row" v-validate="'required'" data-vv-name="Pihak Tiga"
								class="form-control">
								<option value="">Pilih Pihak Tiga</option>
								<option v-for="(v,i) in masters.pihak3" :value="v.id" :key="i">
									{{v.namaPihak3}}
								</option>
							</select>
							<div v-if="errors.has('Pihak Tiga')">
								<p class="text-danger mb-0">{{ errors.first('Pihak Tiga') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Rincian</label>
						<div class="col-md-9">
							<table class="table b-table">
								<thead>
									<tr>
										<th width="55%">Kode Limbah</th>
										<th width="30%">Tonase (Kg)</th>
										<th width="15%"></th>
									</tr>
								</thead>
								<tbody>
									<template v-if="models.RincianAngkuts.length">
										<tr v-for="(v, k) in models.RincianAngkuts">
											<td>
												<select v-model="v.limbahB3Id" required class="form-control">
													<option value="">Pilih Limbah B3</option>
													<option v-for="(v,i) in masters.limbahB3" :value="v.id" :key="i">
														{{v.kodeLimbah}} - {{v.namaLimbah}}
													</option>
												</select>
											</td>
											<td>
												<input type="number" class="form-control" v-model="v.beratTonase" required />
											</td>
											<td class="text-center">
												<a href="javascript:void(0);" @click="models.RincianAngkuts.splice(k, 1)" class="btn btn-danger btn-sm">
													<i class="fa fa-trash"></i>
												</a>
												<a href="javascript:void(0);" v-if="(k+1)== models.RincianAngkuts.length" @click="addRincian" class="btn btn-success btn-sm">
													<i class="fa fa-plus"></i>
												</a>
											</td>
										</tr>
									</template>
									<tr v-else>
										<td colspan="3" align="center">
											<a href="javascript:void(0);" @click="addRincian" class="btn btn-default btn-sm">Tambah Rincian</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Upload Manifes (PDF)</label>
						<div class="col-md-9">
							<input type="hidden" v-model="models.ManifestFile" v-validate="'required'" data-vv-name="Manifes"/>
							<input type="file" accept="application/pdf" class="form-control" v-on:change="addManifes"/>
							<div v-if="errors.has('Manifes')">
								<p class="text-danger mb-0">{{ errors.first('Manifes') }}</p>
							</div>
							<p v-if="models.ManifestFile">
								<a :href="config.asset_url + models.ManifestFile" target="_blank">Lihat File</a>
							</p>
						</div>
					</div>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import moment from 'moment';
	import DatePicker from 'vue2-datepicker';
  	import 'vue2-datepicker/index.css';

	export default {
		name: 'FormLimbahB3Terkelola',
		components: {
			ResponseAlert,
			DatePicker
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					asset_url: process.env.VUE_APP_ASSET,
					maxFileSize: 5 * 1024 * 1024, // 5mb
					disabled: {
						kota: false,
						kecamatan: false,
					}
				},
				models: {
					Skala: "kecamatan",
					JenisFasilitas: "6",
					KotaId: "",
					KecamatanId: "",
					SudinId: "",
					Pihak3Id: "",
					FasilitasB3Id: "",
					FasilitasB3Alamat: "",
					KodeFasilitasB3: "",
					KodePihak3: "",
					TglAngkut: moment().format('YYYY-MM-DD'),
					ManifestFile: "",
					RincianAngkuts: [],
					PickupStatus: '1',
					CreatedBy: "",
				},
				masters: {
					cities: [],
					districts: [],
					fasilitasB3: [],
					sudin: [],
					pihak3: [],
					limbahB3: [],
					FormData: new FormData(),
				}
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getCities();
			_.getLimbahB3();
			_.getUser();
		},
		methods: {
			disabledDate: function (date) {
				// const now = moment();
				// if(now.format('DD') >= 7){
				// 	return date < moment();
				// }
			},
			async getUser() {
				const _ = this;
				const request = await _.$axios.get(`Authentication/me`);
				if(request){
					let user = request.data.data;
					if(user.kota){
						if (!_.$route.params.id) {
							_.models.KotaId = user.kota.id;
							_.getDistrictByCity(false);
						}
						_.config.disabled.kota = true;
					}

					if(user.kecamatan){
						if (!_.$route.params.id) {
							_.models.KecamatanId = user.kecamatan.id;
						}
						_.config.disabled.kecamatan = true;
					}
				}
			},
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`LimbahB3Terkelola/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.Skala = 'kota';
						_.models.KotaId = data.fasilitasB3TPS.kotaId;
						_.models.JenisFasilitas = "5";
						if(data.fasilitasB3TPS){
							if(_.models.KecamatanId = data.fasilitasB3TPS.kecamatanId){
								_.models.Skala = 'kecamatan';
								_.models.JenisFasilitas = "6";
							}
						}

						_.models.Pihak3Id = data.pihak3Id;
						_.models.SudinId = data.pihak3 ? data.pihak3.sudinId : "";
						_.models.FasilitasB3Id = data.fasilitasB3Id;
						_.models.KodeFasilitasB3 = data.kodeFasilitasB3;
						_.models.FasilitasB3Alamat = data.fasilitasB3TPS ? data.fasilitasB3TPS.alamatFasilitas : "";
						_.models.KodePihak3 = data.kodePihak3;
						_.models.TglAngkut = moment(data.tglAngkut).format('YYYY-MM-DD');
						_.models.ManifestFile = data.manifest;
						_.models.RincianAngkuts = data.rincianAngkuts;
						_.models.PickupStatus = data.pickupStatus ? String(data.pickupStatus) : '0';
						_.models.CreatedBy = data.createdBy;
						_.models.UpdatedBy = data.updatedBy;
						_.getDistrictByCity(false);
						_.getPihak3(false);
						_.getLimbahB3();
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			getCities() {
				const _ = this
				_.$axios.get('Kota')
				.then(res => {
					_.masters.cities = res.data.data;
				});
			},
			getDistrictByCity(reset = true) {
				const _ = this
				_.$axios.get('Kecamatan/ByKotaId/' + _.models.KotaId)
				.then(res => {
					if(reset === true){
						_.models.KecamatanId = "";
						_.models.FasilitasB3Id = "";
						_.models.FasilitasB3Alamat = "";
					}
					_.masters.districts = res.data.data;
					_.getFasilitasB3(_.models.KecamatanId == '');
					_.getSudinByKota(_.models.KecamatanId == '');
				});
			},
			getFasilitasB3(reset = true) {
				const _ = this
				const params = {};
				if(_.models.KotaId){
					params.kotaId = _.models.KotaId;
				}
				if(_.models.KecamatanId){
					params.kecamatanId = _.models.KecamatanId;
				}
				params.jenisFasilitas = (_.models.KecamatanId) ? '6' : '5';
				
				_.$axios.get('FasilitasB3TPS/byLocation',{ params })
				.then(res => {
					if(reset === true){
						_.models.FasilitasB3Id = "";
						_.models.KodeFasilitasB3 = "";
						_.models.FasilitasB3Alamat = "";
					}
					_.masters.fasilitasB3 = res.data.data;
				});
			},
			getFasilitasB3Row(){
				const _ = this;
				_.models.KodeFasilitasB3 = "";
				_.models.FasilitasB3Alamat = "";
				for(let i = 0; i < _.masters.fasilitasB3.length; i++){
					if(_.masters.fasilitasB3[i].id == _.models.FasilitasB3Id){
						_.models.FasilitasB3Alamat = _.masters.fasilitasB3[i].alamatFasilitas;
						_.models.KodeFasilitasB3 = _.masters.fasilitasB3[i].kodeFasilitas;
						break;
					}
				}
			},
			getPihak3Row(){
				const _ = this;
				_.models.KodePihak3 = "";
				for(let i = 0; i < _.masters.pihak3.length; i++){
					if(_.masters.pihak3[i].id == _.models.Pihak3Id){
						_.models.KodePihak3 = _.masters.pihak3[i].kodePihak3;
						break;
					}
				}
			},
			getSudinByKota(reset) {
				const _ = this
				_.$axios.get('Sudin/ByKotaId/' + _.models.KotaId)
				.then(res => {
					if(reset === true){
						_.models.SudinId = "";
						_.models.Pihak3Id = "";
						_.models.KodePihak3 = "";
					}
					_.masters.sudin = res.data.data;
				});
			},
			getPihak3(reset = true) {
				const _ = this
				_.$axios.get('Pihak3')
				.then(res => {
					if(reset == true){
						_.models.Pihak3Id = "";
					}
					_.masters.pihak3 = res.data.data;
				});
			},
			getLimbahB3() {
				const _ = this
				_.$axios.get('LimbahB3/filter',{
					params: {
						rumahTangga: true,
						umk: true,
						fasyankes: false,
						pelakuUsaha: false,
					}
				})
				.then(res => {
					_.masters.limbahB3 = res.data.data;
				});
			},
			addRincian(){
				const _ = this;
				const user = JSON.parse(localStorage.getItem('user'));
				_.models.RincianAngkuts.push({
					limbahB3Id: "",
					beratTonase: 0
				});
			},
			addManifes(event) {
				const file = event.target.files[0];
				if (file) {
					if (file.size > this.config.maxFileSize) {
						this.$refs.response.setResponse('Maksimal ukuran file adalah 5 Mb', 'danger');
						this.models.ManifestFile = '';
						window.scrollTo(0, 0);
					} else {
						this.models.ManifestFile = file;
					}
				}
			},
			save() {
				const _ = this;
				const user = JSON.parse(localStorage.getItem('user'));
				_.$validator.validate().then(valid => {
					if (valid) {
						_.masters.FormData = new FormData();
						for (const i in _.models) {
							if(_.models[i]){
								if(i == 'RincianAngkuts'){
									_.models.RincianAngkuts.forEach((v, k) => {
										_.masters.FormData.append(`RincianAngkuts[${k}][limbahB3Id]`, v.limbahB3Id);
										_.masters.FormData.append(`RincianAngkuts[${k}][beratTonase]`, v.beratTonase);
									});
								} else {
									_.masters.FormData.append(i, _.models[i]);
								}
							}
						}
						let request = "";
						if (!_.$route.params.id) {
							_.masters.FormData.append('CreatedBy', user.name);
							request = _.$axios.post(`LimbahB3Terkelola`, _.masters.FormData);
						} else {
							_.masters.FormData.append('id', Number(_.$route.params.id));
							_.masters.FormData.append('updatedBy', user.name);
							request = _.$axios.put(`LimbahB3Terkelola/${_.$route.params.id}`, _.masters.FormData);
						}
						request
						.then(() => _.$router.push({
							name: _.config.uri
						}))
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
						
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>